// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6e61991a","667":"787bc848","977":"a79d28cf"}[chunkId] + ".chunk.js";
};